import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { Table, Button, UncontrolledTooltip } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { useDispatch } from "react-redux";
import { actionGetKitTypes } from 'store/actions/kitsActions';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const TablePatientKits = (props) => {
    const { data, loading, page, callback } = props;
    const { t } = props;
    const kitTypes = useSelector(state => state.kitsReducer.types);
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (!Object.keys(kitTypes).length) {
            dispatch(actionGetKitTypes());
        }
    }, []);

    const editPatientKit = (e, k) => {
        e.preventDefault();
        history.push(`/admin/kits/patients/details/${k._id}`);
    }

    const copyIdToClipboard = (e, kitId) => {
        e.preventDefault();
        navigator.clipboard.writeText(kitId);
        toast.success(t("id-copied"));
    };

    const deletePatientKit = (e, k) => {
        
    }

    return (
        <>

            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table>
                        <thead>
                            <tr>
                                <th> {t("practice")}</th>
                                <th> {t("doctor")}</th>
                                <th> {t("patient")}</th>
                                <th> {t("friendly_id")}</th>
                                <th> {t("type")}</th>
                                <th> {t("status")}</th>
                                <th> {t("assets")}</th>
                                <th> {t("actions")} </th>
                                <th></th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <th>{p.delivery_info.practice.name} <br/><small>({p.delivery_info.practice.owner.firstName} {p.delivery_info.practice.owner.lastName} {p.delivery_info.practice.owner.auth_user_id})</small></th>

                                        <th>{`${p.delivery_info.doctor.firstName} ${p.delivery_info.doctor.lastName}`}</th>
                                        <th>{`${p.delivery_info.patient.firstName} ${p.delivery_info.patient.lastName}`}</th>

                                        <th>
                                            <span className="mr-2">{p.friendly_id}</span>
                                            <div
                                                className="copy-icon"
                                                onClick={(e) => copyIdToClipboard(e, p.friendly_id)}
                                                id={`tooltip-detail-${index}`}
                                            >
                                                <i className="now-ui-icons files_single-copy-04"></i>
                                            </div>

                                            <UncontrolledTooltip placement="top" target={`tooltip-detail-${index}`}>
                                                {p.friendly_id}
                                            </UncontrolledTooltip>
                                        </th>

                                        <th>
                                            {p.type}
                                        </th>

                                        <th>
                                            {t(p.status)}
                                        </th>
                                        
                                        <th>
                                            {p.assets.map(a => {
                                                return (
                                                    <div className="table-assigned-assets" key={`av-${a._id}`}>
                                                        <small>{`${a.asset_type}(${a.brand})`}</small>
                                                    </div>
                                                )
                                            })}
                                        </th>
                                        <th>
                                            <Button
                                                onClick={e => editPatientKit(e, p)}
                                                className="btn-icon btn-round"
                                                color="warning"
                                                size="md"
                                            >
                                                <i className="fa fa-edit" />
                                            </Button>

                                            {p.status !== "k_st_deleted" ? (
                                                <Button
                                                    onClick={e => deletePatientKit(e, p)}
                                                    className="btn-icon btn-round"
                                                    color="danger"
                                                    size="md"
                                                >
                                                    <i className="fa fa-times" />
                                                </Button>
                                            ) : (<></>)}
                                        </th>
                                    </tr>
                                </tbody>
                            )
                        })
                        )}
                    </Table>
                </div>)}

        </>
    );
};
TablePatientKits.defaultProps = {
    data: [],
    loading: true
};

TablePatientKits.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("kits")(TablePatientKits);